import { Injectable } from '@angular/core';
import { EMPTY, Observable, of } from 'rxjs';
import { AuthUser } from './auth-user.model';

/**
 * Represents a dummy authentification service.
 * A real implementation should be provided using dependency injection
 * e.g. `{ provide: AuthService, useClass: MyAuthService }`.
 */
@Injectable({
  providedIn: 'root',
})
export class AuthService {
  userState$: Observable<null | AuthUser> = EMPTY;
  errors$: Observable<any> = EMPTY;
  loginChanged$: Observable<boolean>;
  tokenExpiring$: Observable<number>;

  signIn(returnPath?: string): void { console.log('AuthService return-url', returnPath); }
  resetPassword(returnPath?: string): void { console.log('AuthService return-url', returnPath); }
  signOut(): void { }
  isLoggedIn(): Observable<boolean> { return of(false); }
}
